import React, { useId } from 'react';
import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';
import './LoginInputOtp.css';

function Slot({ char, hasFakeCaret, isActive, invalid }) {
  return (
    <div
      className={[
        'login-otp-slot',
        isActive ? 'login-otp-slot--active' : '',
        char ? 'login-otp-slot--filled' : '',
        invalid ? 'login-otp-slot--invalid' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {char}
      {hasFakeCaret ? <div className="login-otp-caret" /> : null}
    </div>
  );
}

/**
 * Input OTP 6 dígitos (estilo shadcn / input-otp).
 * @see https://ui.shadcn.com/docs/components/base/input-otp
 */
export default function LoginInputOtp({
  value,
  onChange,
  onComplete,
  disabled = false,
  invalid = false,
  autoFocus = true,
}) {
  const id = useId();

  return (
    <div className="login-otp-wrap" data-invalid={invalid ? 'true' : undefined}>
      <OTPInput
        id={id}
        maxLength={6}
        value={value}
        onChange={onChange}
        onComplete={onComplete}
        disabled={disabled}
        pattern={REGEXP_ONLY_DIGITS}
        inputMode="numeric"
        autoFocus={autoFocus}
        containerClassName="login-otp-container"
        render={({ slots }) => (
          <div className="login-otp-group" role="group" aria-label="Código de 6 dígitos">
            {slots.map((slot, i) => (
              <Slot key={i} {...slot} invalid={invalid} />
            ))}
          </div>
        )}
      />
    </div>
  );
}
